import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';

@Component({
  selector: 'app-change-popcorn-modal',
  templateUrl: './change-popcorn-modal.component.html',
  styleUrls: ['./change-popcorn-modal.component.scss'],
})
export class ChangePopcornModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangePopcornModalComponent>,
    private api: BusApiService,
    private router: Router
  ) {}

  loading = false;
  async changePopcorn() {
    try {
      this.loading = true;
      const r = await this.api.changePopcorn(
        this.data.id,
        this.data.started_time,
        this.data.ended_time
      );
      if (r.status === 0) {
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
